import { Badge, cn } from '@newfront-insurance/core-ui/v2';
import type { JSX } from 'react';

import { type NovaSearchAccountResult } from './use-account-search';

interface SearchRowProps {
  account: NovaSearchAccountResult | null;
  onClick?: () => void;
  isSelected?: boolean;
  className?: string;
}

export function SearchRow({ account, onClick, isSelected = false, className }: SearchRowProps): JSX.Element {
  const baseButtonClasses = cn(
    'hover:bg-muted flex w-full text-left',
    {
      'bg-brand-200': isSelected,
    },
    className,
  );

  return (
    <button type="button" className={cn(baseButtonClasses, 'items-start gap-2 px-3 py-2')} onClick={onClick}>
      <div className="min-w-0 flex-1 space-y-1">
        {account && (
          <>
            <div className="flex items-center justify-between">
              <span className="truncate text-sm font-medium">{account.label}</span>
              {account.badges && account.badges.length > 0 && (
                <div className="flex gap-1">
                  {account.badges.map((badge) => {
                    const badgeVariant = badge === 'TR' ? 'glitter' : 'primary';
                    return (
                      <Badge
                        key={badge}
                        variant={badgeVariant}
                        className={cn('px-2 text-xs', { 'bg-[#021a3c] text-white': badge === 'BI' })}
                      >
                        {badge}
                      </Badge>
                    );
                  })}
                </div>
              )}
            </div>
            {account.description && (
              <div className="text-muted-foreground truncate text-xs">
                {account?.description ?? 'Chat without account context.'}
              </div>
            )}
          </>
        )}
      </div>
    </button>
  );
}
